import * as React from 'react'

const IconEduApp = (props) => (
  <svg
    xmlSpace='preserve'
    width={209}
    height={209}
    viewBox='0 0 209.321 209.32'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <defs>
      <linearGradient
        x1={0}
        y1={0}
        x2={1}
        y2={0}
        gradientUnits='userSpaceOnUse'
        gradientTransform='scale(2077.23 -2077.23) rotate(-41.236 -.037 .042)'
        spreadMethod='pad'
        id='edu-app-icon_svg__b'
      >
        <stop
          style={{
            stopOpacity: 1,
            stopColor: '#3c83cd',
          }}
          offset={0}
        />
        <stop
          style={{
            stopOpacity: 1,
            stopColor: '#55c5a7',
          }}
          offset={1}
        />
      </linearGradient>
      <clipPath clipPathUnits='userSpaceOnUse' id='edu-app-icon_svg__a'>
        <path d='M1324.19 0H245.711C110.008 0 0 110.012 0 245.711V1324.19c0 135.7 110.008 245.71 245.711 245.71H1324.19c135.71 0 245.72-110.01 245.72-245.71V245.711C1569.91 110.012 1459.9 0 1324.19 0Z' />
      </clipPath>
    </defs>
    <g
      clipPath='url(#edu-app-icon_svg__a)'
      transform='matrix(.13333 0 0 -.13333 0 209.32)'
    >
      <path
        d='M1324.19 0H245.711C110.008 0 0 110.012 0 245.711V1324.19c0 135.7 110.008 245.71 245.711 245.71H1324.19c135.71 0 245.72-110.01 245.72-245.71V245.711C1569.91 110.012 1459.9 0 1324.19 0'
        style={{
          fill: 'url(#edu-app-icon_svg__b)',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d='M816.488 852.797c-46.738 0-84.84-38.356-84.84-85.492 0-47.188 38.102-85.586 84.84-85.586 46.719 0 84.766 38.398 84.766 85.586 0 47.136-38.047 85.492-84.766 85.492M512.273 851.793c-49.769 0-90.203-38.367-90.203-85.574v-1.082l160.188 55.062c-17.039 19.922-42.672 31.594-69.985 31.594'
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform='matrix(.13333 0 0 -.13333 0 209.32)'
    />
    <path
      d='M1260.52 755.781c-.03-71.574-60.06-129.777-133.87-129.777l.04.031-.07-.031c-73.81 0-133.854 58.234-133.854 129.816v122.11c0 15.746 12.824 28.554 28.614 28.554 15.81 0 28.69-12.808 28.69-28.554V755.82c0-39.992 34.35-72.539 76.55-72.539 42.29 0 76.69 32.547 76.69 72.539v121.989c0 15.711 12.81 28.636 28.6 28.636 15.78 0 28.63-12.925 28.63-31.875V755.82ZM958.5 767.305c0-78.742-63.652-142.871-142.012-142.871-78.285 0-142.015 64.129-142.015 142.871 0 78.73 63.73 142.797 142.015 142.797 30.731 0 60.332-9.961 84.766-28.372v108.036c0 15.784 12.773 28.604 28.613 28.604 15.781 0 28.633-12.82 28.633-28.604zm-308.473 24.769c-3.199-6.871-9.183-12.289-16.394-14.801l-190.879-65.468c17.016-19.649 42.43-31.094 69.519-31.094 28.145 0 54.297 12.148 71.563 33.352 5.367 6.667 13.519 10.566 22.141 10.566 6.472 0 12.949-2.316 18.074-6.406 12.238-9.973 14.105-27.95 4.211-40.266-28.223-34.734-70.481-54.539-115.989-54.539-81.343 0-147.507 64.062-147.507 142.801 0 78.801 66.164 142.851 147.507 142.851 62.204 0 118.004-38.125 138.911-94.843 2.636-7.133 2.367-15.243-1.157-22.153zm159.078 484.696H286.273c-25.988 0-35.097-34.48-12.5-47.31l27.008-15.35h-.008c26.543-15.08 80.895-45.95 80.895-45.95 57.5-34.85 42.227-82.12 29.668-105.26-57.555-83.865-89.809-186.451-85.688-296.787C335.141 512.082 541 304.738 794.973 293.609 1075.69 281.32 1307.3 504.352 1308.98 781.922c1.65 274.108-225.75 494.848-499.875 494.848'
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform='matrix(.13333 0 0 -.13333 0 209.32)'
    />
  </svg>
)

export default IconEduApp

